"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallText = exports.BodyText = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Caption = exports.Code = exports.Overline = exports.SmallParagraph = exports.Paragraph = exports.ExtraSmallHeading = exports.SmallHeading = exports.MediumHeading = exports.LargeHeading = exports.ExtraLargeHeading = void 0;
var React = __importStar(require("react"));
var Text_1 = require("./Text");
var ExtraLargeHeading = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h1", color: "n900", fontSize: "fontsize28", fontWeight: "bold", lineHeight: 1.25 }, props), children));
};
exports.ExtraLargeHeading = ExtraLargeHeading;
var LargeHeading = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h2", color: "n900", fontSize: "fontsize24", fontWeight: "medium", lineHeight: 1.3333333 }, props), children));
};
exports.LargeHeading = LargeHeading;
var MediumHeading = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h3", color: "n900", fontSize: "fontsize20", fontWeight: "medium", lineHeight: 1.4 }, props), children));
};
exports.MediumHeading = MediumHeading;
var SmallHeading = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h4", color: "n900", fontSize: "fontsize16", fontWeight: "medium", lineHeight: 1.5 }, props), children));
};
exports.SmallHeading = SmallHeading;
var ExtraSmallHeading = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h5", color: "n900", fontSize: "fontsize14", fontWeight: "medium", lineHeight: 1.7142857143 }, props), children));
};
exports.ExtraSmallHeading = ExtraSmallHeading;
var Paragraph = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "p", color: "n900", fontSize: "fontsize16", fontWeight: "regular", lineHeight: 1.5 }, props), children));
};
exports.Paragraph = Paragraph;
var SmallParagraph = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "p", color: "n900", fontSize: "fontsize14", fontWeight: "regular", lineHeight: 1.4285714286 }, props), children));
};
exports.SmallParagraph = SmallParagraph;
var Overline = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ color: "n400", fontSize: "fontsize13", fontWeight: "bold", lineHeight: 1.2307692308 }, props), children));
};
exports.Overline = Overline;
var Code = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "code", fontFamily: "mono", color: "n900", fontSize: "fontsize14", fontWeight: "regular", lineHeight: 1.4285714286 }, props), children));
};
exports.Code = Code;
var Caption = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "caption", fontFamily: "mono", color: "n400", fontSize: "fontsize12", fontWeight: "regular", lineHeight: 1.3333333333 }, props), children));
};
exports.Caption = Caption;
var H1 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h1", color: "n900", fontSize: "h1", fontWeight: "semiBold", lineHeight: "h1" }, props), children));
};
exports.H1 = H1;
var H2 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h2", color: "n900", fontSize: "h2", fontWeight: "semiBold", lineHeight: "h2" }, props), children));
};
exports.H2 = H2;
var H3 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h3", color: "n900", fontSize: "h3", fontWeight: "semiBold", lineHeight: "h3" }, props), children));
};
exports.H3 = H3;
var H4 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h4", color: "n900", fontSize: "h4", fontWeight: "semiBold", lineHeight: "h4" }, props), children));
};
exports.H4 = H4;
var H5 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h5", color: "n900", fontSize: "h5", fontWeight: "semiBold", lineHeight: "h5" }, props), children));
};
exports.H5 = H5;
var H6 = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "h6", color: "n900", fontSize: "h6", fontWeight: "semiBold", lineHeight: "h6" }, props), children));
};
exports.H6 = H6;
var BodyText = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "p", color: "n900", fontSize: "body", lineHeight: "body" }, props), children));
};
exports.BodyText = BodyText;
var SmallText = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text_1.Text, __assign({ as: "p", color: "n900", fontSize: "small", lineHeight: "small" }, props), children));
};
exports.SmallText = SmallText;
//# sourceMappingURL=index.js.map